/* Moosy · moosy-theme.js (vanilla, defer). Core + barra annunci + menu + popup. */
/* Moosy · theme.js (vanilla, nessuna dipendenza)
   In Shopify: assets/theme.js caricato con defer. */
(function () {
  const M = (window.Moosy = window.Moosy || {});

  /* Tracciamento: dataLayer GA4-style. I pixel leggono da qui solo dopo il consenso (CMP). */
  window.dataLayer = window.dataLayer || [];
  M.track = function (event, params) {
    const payload = Object.assign({ event: event, event_id: event + '_' + Date.now() + '_' + Math.random().toString(36).slice(2, 7) }, params || {});
    window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent('moosy:track', { detail: payload }));
  };
  /* Preferenze cookie (footer) -> pannello Consentmo */ document.addEventListener('click',function(e){var b=e.target.closest('[data-cookie-prefs]');if(!b)return;e.preventDefault();if(typeof window.showPreferences==='function')window.showPreferences();});
  /* Soldi: centesimi -> "69,90 €" */
  M.money = function (cents) {
    return (cents / 100).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  };

  /* Data di consegna stimata: oggi + N giorni lavorativi, weekend e festivi nazionali esclusi. */
  function easter(y) {
    const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4,
      f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30,
      i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
      month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(y, month - 1, day);
  }
  function isHoliday(d) {
    const md = (d.getMonth() + 1) + '-' + d.getDate();
    const fixed = ['1-1', '1-6', '4-25', '5-1', '6-2', '8-15', '11-1', '12-8', '12-25', '12-26'];
    if (fixed.indexOf(md) > -1) return true;
    const em = easter(d.getFullYear()); em.setDate(em.getDate() + 1); // Lunedì dell'Angelo
    return d.getMonth() === em.getMonth() && d.getDate() === em.getDate();
  }
  M.addBusinessDays = function (from, n) {
    const d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    let added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      const wd = d.getDay();
      if (wd !== 0 && wd !== 6 && !isHoliday(d)) added++;
    }
    return d;
  };
  M.formatDay = function (d, withMonth) {
    const s = d.toLocaleDateString('it-IT', withMonth ? { weekday: 'short', day: 'numeric', month: 'long' } : { weekday: 'short', day: 'numeric' });
    return s.replace('.', '');
  };
  M.deliveryRange = function (minDays, maxDays) {
    const now = new Date();
    const a = M.addBusinessDays(now, minDays), b = M.addBusinessDays(now, maxDays);
    const sameMonth = a.getMonth() === b.getMonth();
    return { from: M.formatDay(a, !sameMonth), to: M.formatDay(b, true) };
  };

  /* Carrello: in Shopify usa /cart/add.js; in anteprima locale simula la risposta. */
  M.cartAdd = async function (items) {
    const isShopify = !!(window.Shopify && window.Shopify.shop);
    if (isShopify) {
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) });
      if (!r.ok) throw new Error('cart_add_failed');
      const data = await r.json();
      document.dispatchEvent(new CustomEvent('moosy:cart:added', { detail: data }));
      return data;
    }
    await new Promise((res) => setTimeout(res, 450));
    const data = { items: items, preview: true };
    document.dispatchEvent(new CustomEvent('moosy:cart:added', { detail: data }));
    return data;
  };
})();


/* ---- ann ---- */
(function(){
  const bar=document.querySelector('.m-ann'); if(!bar) return;
  const msgs=[...bar.querySelectorAll('.m-ann__msg')]; if(msgs.length<2) return;
  const sec=(+bar.dataset.rotate||5)*1000; let i=0, t=null;
  const go=()=>{msgs[i].classList.remove('is-on');msgs[i].setAttribute('aria-hidden','true');i=(i+1)%msgs.length;msgs[i].classList.add('is-on');msgs[i].removeAttribute('aria-hidden');};
  const start=()=>{t=setInterval(go,sec)}, stop=()=>{clearInterval(t)};
  start(); bar.addEventListener('mouseenter',stop); bar.addEventListener('mouseleave',start);
  document.addEventListener('visibilitychange',()=>document.hidden?stop():start());
})();

/* ---- hdr_mm ---- */
(function(){
  const m=document.querySelector('[data-mm]'), b=document.querySelector('[data-mm-open]'); if(!m||!b) return;
  const panel=m.querySelector('.mm__panel');
  function open(){ m.hidden=false; document.documentElement.classList.add('mm-lock'); b.setAttribute('aria-expanded','true'); requestAnimationFrame(()=>{m.classList.add('is-open'); panel.focus();}); }
  function close(back){ m.classList.remove('is-open'); document.documentElement.classList.remove('mm-lock'); b.setAttribute('aria-expanded','false'); setTimeout(()=>{m.hidden=true; if(back!==false) b.focus();},280); }
  b.addEventListener('click',open);
  m.querySelectorAll('[data-mm-close]').forEach(x=>x.addEventListener('click',()=>close()));
  m.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{ if((a.getAttribute('href')||'').startsWith('#')) close(false); }));
  m.addEventListener('keydown',e=>{ if(e.key==='Escape') close();
    if(e.key==='Tab'){ const f=[...panel.querySelectorAll('a[href],button')]; if(e.shiftKey&&document.activeElement===f[0]){e.preventDefault();f[f.length-1].focus();} else if(!e.shiftKey&&document.activeElement===f[f.length-1]){e.preventDefault();f[0].focus();} } });
})();

/* ---- foot ---- */
(function(){document.querySelectorAll('[data-foot-link]').forEach(a=>a.addEventListener('click',()=>window.Moosy.track('footer_link',{label:a.textContent})));})();

/* ---- pop ---- */
(function(){
  const root=document.querySelector('[data-pop]'); if(!root) return; const M=window.Moosy;
  const C=JSON.parse(document.querySelector('[data-pop-json]').textContent);
  const box=root.querySelector('.m-pop__box'), form=root.querySelector('[data-pop-form]'), done=root.querySelector('[data-pop-done]'), err=root.querySelector('[data-pop-err]'), teaser=document.querySelector('[data-pop-teaser]');
  const isShopify=!!(window.Shopify&&window.Shopify.shop);
  const store={get(k){try{return localStorage.getItem(k)}catch(e){return null}},set(k,v){try{localStorage.setItem(k,v)}catch(e){}}};
  const DAY=864e5, now=Date.now();
  const signed=+store.get('moosy_pop_signed')||0, closed=+store.get('moosy_pop_closed')||0;
  const blocked=()=>{const c=document.documentElement.classList; return c.contains('m-lock')||c.contains('mm-lock');};  // carrello o menu aperti
  let opener=null, lastAdd=0;
  document.addEventListener('moosy:cart:added',()=>lastAdd=Date.now());

  function open(src){ if(!root.hidden) return; opener=document.activeElement; root.hidden=false; if(teaser) teaser.hidden=true;
    document.documentElement.classList.add('m-lock');
    requestAnimationFrame(()=>{root.classList.add('is-open'); (form.hidden?box:root.querySelector('#pop-email')).focus({preventScroll:true});});
    M.track('popup_view',{source:src}); }
  function close(src){ root.classList.remove('is-open'); document.documentElement.classList.remove('m-lock');
    setTimeout(()=>{root.hidden=true; if(opener&&opener.focus) opener.focus({preventScroll:true});},350);
    if(!done.hidden) return;  // già iscritto: niente linguetta
    store.set('moosy_pop_closed',String(Date.now())); if(teaser) teaser.hidden=false; M.track('popup_close',{source:src||'x'}); }
  root.querySelectorAll('[data-pop-close]').forEach(b=>b.addEventListener('click',()=>close(b.classList.contains('m-pop__no')?'no_thanks':'x')));
  root.addEventListener('keydown',e=>{ if(e.key==='Escape') close('esc');
    if(e.key==='Tab'){const f=[...box.querySelectorAll('button,a[href],input')].filter(x=>x.offsetParent!==null);
      if(e.shiftKey&&document.activeElement===f[0]){e.preventDefault();f[f.length-1].focus();} else if(!e.shiftKey&&document.activeElement===f[f.length-1]){e.preventDefault();f[0].focus();}}});
  if(teaser) teaser.addEventListener('click',()=>{M.track('popup_reopen',{}); open('teaser');});

  // Quando mostrarlo: dopo N secondi, mai sopra il carrello aperto o subito dopo un'aggiunta
  const params=new URLSearchParams(location.search);
  function tryOpen(){ if(blocked()||Date.now()-lastAdd<8000){ setTimeout(tryOpen,4000); return; } open('timer'); }
  if(params.has('popup')) setTimeout(()=>open('url'),300);
  else if(signed) {}
  else if(closed&&now-closed<C.hide_days_after_close*DAY){ if(teaser) teaser.hidden=false; }
  else setTimeout(tryOpen,C.delay_seconds*1000);

  // Iscrizione: Klaviyo se configurato, altrimenti email di Shopify (cliente con consenso marketing)
  const emailOk=v=>/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
  async function subscribeShopify(email){
    if(!isShopify){ await new Promise(r=>setTimeout(r,600)); return true; }  // anteprima locale
    const fd=new FormData();
    fd.append('form_type','customer'); fd.append('utf8','✓');
    fd.append('contact[email]',email);
    fd.append('contact[tags]','newsletter,popup-moosy');
    fd.append('contact[accepts_marketing]','true');
    try{
      const r=await fetch('/contact',{method:'POST',body:fd,credentials:'same-origin'});
      if(/challenge/.test(r.url||'')) M.track('popup_signup_challenge',{});
      return r.ok||r.status===302||r.type==='opaqueredirect';
    }catch(x){ return false; }
  }
  async function subscribe(email){
    if(!C.klaviyo.public_key) return subscribeShopify(email);
    const body={data:{type:'subscription',attributes:{profile:{data:{type:'profile',attributes:{email,properties:{fonte:'popup_landing',codice:C.discount_code}}}},
      custom_source:'Moosy popup landing'},relationships:{list:{data:{type:'list',id:C.klaviyo.list_id}}}}};
    const r=await fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+encodeURIComponent(C.klaviyo.public_key),
      {method:'POST',headers:{'Content-Type':'application/json',revision:'2024-10-15'},body:JSON.stringify(body)});
    return r.status===202||r.ok;
  }
  form.addEventListener('submit',async e=>{ e.preventDefault();
    const inp=form.email, v=inp.value.trim(); err.textContent=''; inp.removeAttribute('aria-invalid');
    if(!emailOk(v)){ err.textContent=C.t.error_email; inp.setAttribute('aria-invalid','true'); inp.focus(); return; }
    if(!form.consent.checked){ err.textContent=C.t.error_consent; form.consent.focus(); return; }
    const btn=root.querySelector('[data-pop-submit]'); btn.setAttribute('aria-busy','true'); btn.disabled=true; M.track('popup_submit',{});
    try{ const ok=await subscribe(v); if(!ok) throw new Error('signup');
      if(isShopify) fetch('/discount/'+encodeURIComponent(C.discount_code),{credentials:'same-origin'}).catch(()=>{});
      store.set('moosy_pop_signed',String(Date.now())); form.hidden=true; done.hidden=false; root.querySelector('[data-pop-done-t]').focus();
      M.track('popup_success',{code:C.discount_code}); document.dispatchEvent(new CustomEvent('moosy:discount',{detail:{code:C.discount_code,pct:C.discount_pct}}));
    }catch(x){ err.textContent=C.t.error_net; M.track('popup_error',{}); }
    finally{ btn.removeAttribute('aria-busy'); btn.disabled=false; } });
  root.querySelector('[data-pop-copy]').addEventListener('click',async e=>{ const b=e.currentTarget;
    try{ await navigator.clipboard.writeText(C.discount_code); }catch(x){}
    b.textContent=C.t.copied; setTimeout(()=>b.textContent=C.t.copy,2000); M.track('popup_code_copy',{}); });
  root.querySelectorAll('[data-pop-open]').forEach(b=>b.addEventListener('click',()=>{
    root.classList.add('is-opening'); M.track('popup_gift_open',{});
    setTimeout(()=>{ root.querySelector('[data-pop-gift]').hidden=true; form.hidden=false; root.classList.remove('is-opening'); root.querySelector('#pop-email').focus({preventScroll:true}); }, matchMedia('(prefers-reduced-motion: reduce)').matches?0:480);
  }));
  root.querySelector('[data-pop-go]').addEventListener('click',()=>close('go'));
  M.openPopup=open;
})();
